/**
 * Genis ekran (>=1024px) icin sol kenar cubugu gezinmesi.
 *
 * Dar ekranda GORUNMEZ (bkz. theme.css `.sidebar` + @media min-width:1024px) -
 * App.tsx'teki header'in yatay `.nav`'i kullanilir. Ayni tabs/tab/onTabChange
 * durumunu PAYLASIR - iki ayri gezinme mantigi ICAT EDILMEZ.
 */

import type { ReactNode } from "react";
import { BrandWatermark } from "./BrandWatermark";
import { IconSettings } from "./Ui";

export interface SidebarTab {
  key: string;
  label: string;
  icon: ReactNode;
  category?: string;
}

export function Sidebar({
  tabs,
  tab,
  onTabChange,
  theme,
  heldAlertPending,
  systemsOk,
  version,
  onSettings,
  onHome,
}: {
  tabs: SidebarTab[];
  tab: string;
  onTabChange: (key: string) => void;
  theme: "light" | "dark";
  heldAlertPending: boolean;
  systemsOk: boolean;
  version?: string;
  onSettings: () => void;
  /** Logoya basinca ana sayfa (Tarama). */
  onHome: () => void;
}) {
  return (
    <aside className="sidebar" aria-label="Ana gezinme">
      <button
        type="button"
        className="sidebar-brand brand-home"
        onClick={onHome}
        aria-label="Ana sayfa (Tarama)"
      >
        <BrandWatermark theme={theme} />
      </button>
      <nav className="sidebar-nav">
        {tabs.map((item) => (
          <button
            key={item.key}
            type="button"
            className="sidebar-item"
            data-category={item.category}
            aria-current={tab === item.key ? "page" : undefined}
            onClick={() => onTabChange(item.key)}
          >
            <span className="nav-icon-wrap">
              {item.icon}
              {item.key === "favorites" && heldAlertPending ? (
                <span className="nav-dot" aria-hidden="true" />
              ) : null}
            </span>
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
      <div className="sidebar-foot">
        <div className="sidebar-status" data-state={systemsOk ? "ok" : "warn"}>
          <span className="pulse" />
          <span className="sidebar-status-text">
            <strong>{systemsOk ? "Sistem Aktif" : "Kontrol Gerekiyor"}</strong>
            <span>
              {systemsOk ? "Tüm sistemler çalışıyor" : "Bir servis sorunlu"}
            </span>
          </span>
        </div>
        <div className="sidebar-version">
          <span>Sinyalix {version ? `v${version}` : ""}</span>
          <button
            type="button"
            className="sidebar-gear"
            onClick={onSettings}
            aria-label="Hesap ve ayarlar"
          >
            <IconSettings />
          </button>
        </div>
      </div>
    </aside>
  );
}
